import { UndefinedInitialDataOptions, useQuery } from '@tanstack/react-query'
import { isAddress } from 'thirdweb'
import { getTokenMetadata } from '../api-clients/alchemy'
import useActiveOrDefaultChain from '../hooks/web3/useActiveOrDefaultChain'
import { ERC20 } from '../types/models/Tokens'

type TokenMetadataQueryOptions = Omit<
  UndefinedInitialDataOptions<ERC20 | null>,
  'queryFn' | 'queryKey'
>

const useTokenMetadata = (
  address?: string,
  options?: TokenMetadataQueryOptions
) => {
  const chain = useActiveOrDefaultChain()
  const { enabled, ...rest } = options ?? {}

  return useQuery({
    queryFn: () => getTokenMetadata(address, chain.id),
    enabled: (!!address && isAddress(address)) || enabled,
    queryKey: ['tokenMetadata', address],
    ...rest,
  })
}

export default useTokenMetadata
